export default {
	0: "pending",
	1: "enabling",
	2: "active",
	3: "inactive"
};
